import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AddExpensesComponent } from 'src/app/AddThings/add-expenses/add-expenses.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { User } from 'src/model/user.model';
import { UserService } from 'src/services/user.service';
import { EditUserComponent } from '../edit-user/edit-user.component';

interface UnpaidStaffCommissionInterface {
  StaffUsername: string;
  StaffBasic: number;
  UnpaidCommissionTotal: number;
}

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    standalone: false
})
export class UserListComponent implements OnInit {
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private cdr = inject(ChangeDetectorRef);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private userService = inject(UserService);

  userList: User[] = [];
  displayedColumns: string[] = ['Username', 'RoleName', 'CompanyName', 'Salary'];
  dataSource = new MatTableDataSource;

  cashAccountList: Account[] = [];
  companyBankAccountList: Account[] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit(): void {
    this.getAllUsers();
    if (this.sharedService.isBossAccount()) {
      this.displayedColumns.push('Actions');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async getAllUsers() {
    this.userList = await this.userService.getAllUsers();

    //make user list as the datasource
    this.dataSource = new MatTableDataSource<User>(this.userList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  confirmDeleteUser(user: User) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete this user (" + user.Username + ") ?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteUser(user);
    });
  }

  deleteUser(user: User) {
    const xhttp = new XMLHttpRequest();
    const url = "http://localhost:10080/api/v1/user/" + user.Username;
    xhttp.open("DELETE", url, true);
    xhttp.withCredentials = true;
    xhttp.setRequestHeader("Content-type", "application/json");

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:
        //  document.getElementById("demo").innerHTML = xhttp.responseText;
        // console.log(this.responseText);

        for (const i in this.userList) {
          if (this.userList[i].Username == user.Username) {
            this.userList.splice(Number(i), 1);
            // this.cdr.detectChanges();
            this.refreshDataSource();
          }
        }
      }
    };
    xhttp.send();
  }

  refreshDataSource() {
    this.dataSource.data = this.userList;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openEditUserDialog(user: User) {
    const modalRef = this.sharedService.openModal(EditUserComponent);
    modalRef.componentInstance.username = user.Username;
    modalRef.componentInstance.amount = user.Salary;
    modalRef.componentInstance.selectedRoleId = user.RoleId;
    modalRef.componentInstance.companyId = user.CompanyId;

    //get user that was updated
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const updatedUser = entry;

      const index = this.userList.findIndex(user => user.Username === updatedUser.Username);
      this.userList[index].Salary = updatedUser.Salary;
      this.userList[index].RoleId = updatedUser.RoleId;
      this.userList[index].RoleName = updatedUser.RoleName;
    });

    modalRef.result.then(() => {
      // console.log("added task")
      // this.cdr.detectChanges();
      this.refreshDataSource();
    })
  }

  openAddSalaryExpenseModal(username: string, amount: number) {
    const companyId = Number(sessionStorage.getItem("companyId"));

    this.getAllAccountsOfCompany(companyId);
    const modalRef = this.sharedService.openModal(AddExpensesComponent);
    modalRef.componentInstance.companyBankAccountList = this.companyBankAccountList;
    modalRef.componentInstance.cashAccountList = this.cashAccountList;
    modalRef.componentInstance.remark = "SALARY - " + username;
    modalRef.componentInstance.amount = amount;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });

    modalRef.result.then(() => {
      this.cdr.detectChanges();
    })
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const amount = (json.balance == undefined) ? 0 : json.balance;
          const account = new Account(json.id, json.number, json.name, json.holderName, amount, json.companyId, json.username);

          if (account.Username != undefined)
            this.cashAccountList.push(account)
          else {
            this.companyBankAccountList.push(account);
          }
        }
        );
      }
    };
  }

  promoteUser(user: User) {
    const data = {
      "roleId": this.enums.BRANCH_MANAGER
    };

    const xhr = this.restapi.putRequest(this.constructApi.getEditUserRole(user.CompanyId, user.Username), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          window.location.reload();

          this.sharedService.openAlert("Successfully promoted user!", ALERT_TYPE.SUCCESS);
        }
        else {
          const json = JSON.parse(xhr.responseText);
          this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER);
        }
      }
    }
  }

  demoteUser(user: User) {
    const data = {
      "roleId": this.enums.STAFF
    };

    const xhr = this.restapi.putRequest(this.constructApi.getEditUserRole(user.CompanyId, user.Username), data);
    xhr.onreadystatechange = () => {
      if (xhr.status == 200) {
        window.location.reload();

        this.sharedService.openAlert("Successfully demoted user!", ALERT_TYPE.SUCCESS);
      }
      else {
        const json = JSON.parse(xhr.responseText);
        this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER);
      }
    }
  }

  confirmBeforeDeactive(user: User) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to deactivate this user - " + user.Username + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deactivateUser(user);
    });
  }

  confirmBeforeDemote(user: User) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to demote this user - " + user.Username + ", make him/her become STAFF?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.demoteUser(user);
    });
  }

  confirmBeforePromote(user: User) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to promote this user - " + user.Username + ", make him/her become BRANCH MANAGER?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.promoteUser(user);
    });
  }

  async deactivateUser(user: User) {
      await this.userService.putDeactivateUser(user.Username);
      this.sharedService.openAlert("Successfully deactivated user!", ALERT_TYPE.SUCCESS);
      window.location.reload();
  }
}
